import { render, staticRenderFns } from "./BCXPaginatedContent.vue?vue&type=template&id=404a6c0c&scoped=true"
import script from "./BCXPaginatedContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXPaginatedContent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXPaginatedContent.vue?vue&type=style&index=0&id=404a6c0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a6c0c",
  null
  
)

export default component.exports